import React from 'react';
import './Cali.css'; 

const Monteria = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKMR.pdf" target="_blank" rel="noreferrer">Aeropuerto Los garzones</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 14</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE3D.pdf" target="_blank" rel="noreferrer">AKPE3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE3D.pdf" target="_blank" rel="noreferrer">BOKU3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE3D.pdf" target="_blank" rel="noreferrer">RAXO3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3C.pdf" target="_blank" rel="noreferrer">AKPA3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3C.pdf" target="_blank" rel="noreferrer">AKPE3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3C.pdf" target="_blank" rel="noreferrer">CZU3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3C.pdf" target="_blank" rel="noreferrer">IRAX3F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3C.pdf" target="_blank" rel="noreferrer">RAXO2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE2F.pdf" target="_blank" rel="noreferrer">AKPE2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE2F.pdf" target="_blank" rel="noreferrer">BOKU2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE2F.pdf" target="_blank" rel="noreferrer">RAXO2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2K.pdf" target="_blank" rel="noreferrer">AKPA2K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2K.pdf" target="_blank" rel="noreferrer">CZU2H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2K.pdf" target="_blank" rel="noreferrer">IRAX3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOGA1B.pdf" target="_blank" rel="noreferrer">BOGA1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOGA1B.pdf" target="_blank" rel="noreferrer">BOGA1C</a></th>
          </tr>
             
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 32</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE4A.pdf" target="_blank" rel="noreferrer">AKPE4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE4A.pdf" target="_blank" rel="noreferrer">BOKU4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE4A.pdf" target="_blank" rel="noreferrer">RAXO4B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3D.pdf" target="_blank" rel="noreferrer">AKPA3D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3D.pdf" target="_blank" rel="noreferrer">CZU3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3D.pdf" target="_blank" rel="noreferrer">IRAX3E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE2E.pdf" target="_blank" rel="noreferrer">AKPE2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE2E.pdf" target="_blank" rel="noreferrer">BOKU2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPE2E.pdf" target="_blank" rel="noreferrer">RAXO2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2J.pdf" target="_blank" rel="noreferrer">AKPA2J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2J.pdf" target="_blank" rel="noreferrer">CZU2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2J.pdf" target="_blank" rel="noreferrer">IRAX2G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOGA1B.pdf" target="_blank" rel="noreferrer">BOGA1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOGA1B.pdf" target="_blank" rel="noreferrer">BOGA1C</a></th>
          </tr>

          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 14</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3B.pdf" target="_blank" rel="noreferrer">AKPA3B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3B.pdf" target="_blank" rel="noreferrer">CZU3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3B.pdf" target="_blank" rel="noreferrer">IRAX3C</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 32</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BUTA4C.pdf" target="_blank" rel="noreferrer">BUTA4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BUTA4D.pdf" target="_blank" rel="noreferrer">BUTA4D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/RAXO5A.pdf" target="_blank" rel="noreferrer">RAXO5A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/RAXO4C.pdf" target="_blank" rel="noreferrer">RAXO4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3G.pdf" target="_blank" rel="noreferrer">AKPA3G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3H.pdf" target="_blank" rel="noreferrer">AKPA3H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3H.pdf" target="_blank" rel="noreferrer">CZU3F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA3H.pdf" target="_blank" rel="noreferrer">IRAX3K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOKU1G.pdf" target="_blank" rel="noreferrer">BOKU1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOKU1G.pdf" target="_blank" rel="noreferrer">BUTA2E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOKU1G.pdf" target="_blank" rel="noreferrer">RAXO1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOKU1G.pdf" target="_blank" rel="noreferrer">XOGE2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2L.pdf" target="_blank" rel="noreferrer">AKPA2L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2L.pdf" target="_blank" rel="noreferrer">CZU2J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/AKPA2L.pdf" target="_blank" rel="noreferrer">IRAX2L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/BOGA2A.pdf" target="_blank" rel="noreferrer">BOGA2A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 14</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/VOR14.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 32</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/ILSZ32.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/ILSY32.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/LOC32.pdf" target="_blank" rel="noreferrer">LOC</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/VOR32.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKMR/RNP32.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Monteria;